import { render, staticRenderFns } from "./ReportingColumn.vue?vue&type=template&id=4b121ecc&scoped=true&"
import script from "./ReportingColumn.vue?vue&type=script&lang=js&"
export * from "./ReportingColumn.vue?vue&type=script&lang=js&"
import style0 from "./ReportingColumn.vue?vue&type=style&index=0&id=4b121ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b121ecc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
